import axios from 'lib/axios';

const createService = async (value) => {
  const { data } = await axios.post('/admin/service', value);
  return data;
};

async function getAllServices(limit = 10, page = 1, query = '', dId) {
  let address = `/admin/service?limit=${limit}&page=${page}&query=${query}`;
  if (dId) {
    address += `&divisionId=${dId}`;
  }
  console.log("address:",address)
  const { data } = await axios.get(
    address
  );
  return data;
}

const getServiceById = async (id) => {
  const { data } = await axios.get(`/admin/service/${id}`);
  return data;
};

const deleteServiceById = async (id) => {
  const { data } = await axios.delete(`/admin/service/${id}`);
  return data;
};

const updateServiceById = async (value) => {
  const { body, id } = value;
  const { data } = await axios.put(`/admin/service/${id}`, body);
  return data;
};

const getQuickServices = async () => {
  const { data } = await axios.get('/admin/service/quick');
  return data;
};

const updateQuickServices = async (serviceIds) => {
  const { data } = await axios.put('/admin/service/quick', { serviceIds });
  return data;
};

export {
  createService,
  getAllServices,
  getServiceById,
  deleteServiceById,
  updateServiceById,
  getQuickServices,
  updateQuickServices,
};
